/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkBacksolveUpdate } from './BulkBacksolveUpdate';
export type BulkValuationUpdate = {
  is_firm_owned?: boolean;
  is_ready_for_audit?: boolean;
  status?: BulkValuationUpdate.status;
  update_transaction_comps?: boolean;
  id: number;
  market_date?: string | null;
  update_requested_at: string;
  backsolve?: BulkBacksolveUpdate;
};
export namespace BulkValuationUpdate {
  export enum status {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',
    FINAL = 'FINAL',
  }
}

